// Standard HTML5 Form Inputs

import { Translation } from "./language";

// https://www.w3schools.com/html/html_form_input_types.asp
export enum FormFieldType {
  // HTML Input
  TEXT = "text",
  EMAIL = "email",
  TEL = "tel",
  DATE = "date",
  DATETIME = "datetime-local",
  TIME = "time",
  URL = "url",

  PASSWORD = "password",

  FILE = "file",
  HIDDEN = "hidden", // Hidden values
  // https://chakra-ui.com/docs/components#form
  NUMBER = "number",
  SELECT = "select",
  CHECKBOX = "checkbox", // ZERO or MORE options of a limited number of choices.
  RADIO = "radio", // ONLY ONE of a limited number of choices
  TOGGLE = "toggle",
  RANGE = "range",
  EDITABLE = "editable",

  TEXTAREA = "textarea",
  RICHTEXT = "richtext",
}

// React Hook Form Error Types
// https://react-hook-form.com/api/useform/register
export type FormFieldErrorTypes =
  | "required"
  | "max"
  | "min"
  | "pattern"
  | "maxLength"
  | "minLength"
  | "validate"
  | "custom";

export interface FormSelectOption {
  label: Translation; // text label for the option
  value: string;
  selected?: boolean;
  disabled?: boolean;
}

export interface FormField {
  type: FormFieldType;
  label: Translation;
  key: string; // Used as id and name
  note?: Translation;
  tooltip?: Translation;
  value?: string | number | boolean | string[]; // default value or value for checkbox/radio
  options?: FormSelectOption[];
  placeholder?: Translation;
  span?: number; // Column span in form layout
  errorMessages?: {
    [key in FormFieldErrorTypes]?: Translation;
  };
  confirm?: boolean; // Re-enter to confirm Input
  // Standard HTML5 Input Restrictions
  disabled?: boolean;
  required?: boolean;
  readonly?: boolean;
  checked?: boolean;
  size?: number;
  step?: number;
  // Form Validation
  max?: number;
  maxLength?: number;
  min?: number;
  minLength?: number;
  pattern?: string;

  // File Upload
  accept?: string;
}
